// @ts-nocheck
import React from 'react';
import Icon from 'jitsi/base/icons/components/Icon';
import { IconSearch } from 'jitsi/base/icons/svg';
import Input from 'jitsi/base/ui/components/web/Input';
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()((theme) => {
    return {
        search: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            margin: `${theme.spacing(2)} 0 ${theme.spacing(3)}`,
            '& input': {
                paddingRight: '52px',
            },
        },
        searchInput: {
            flex: 1,
        },
        searchIcon: {
            position: 'absolute',
            right: theme.spacing(3),
            '& svg': {
                fill: theme.palette.iisightIcon,
            },
        },
    };
});
export const SearchInput = ({ className, ...inputProps }) => {
    const { classes: styles, cx } = useStyles();
    return (React.createElement("div", { className: styles.search },
        React.createElement(Input, { className: cx(styles.searchInput, className), ...inputProps }),
        React.createElement(Icon, { colorInClass: true, className: styles.searchIcon, src: IconSearch })));
};
